import angular from 'angular';
import { UsersService } from '../../shared/users/users.service';

export const UserNameDirective = {
  selector: 'userName',
  restrict: 'E',
  bindings: {
    userId: '<',
    error: '@?',
  },
  template: /* html */`
    <ng-container>{{ $ctrl.userName }}</ng-container>
  `,
  controller: class UserNameController {
    private userName = '';

    private userId!: number;

    private error?: string;

    private usersService: UsersService;

    constructor(
      usersService: UsersService,
    ) {
      'ngInject';

      this.usersService = usersService;
    }

    $onChanges = (): void => {
      const parsedId = parseInt(String(this.userId), 10);
      if (parsedId === -1) {
        this.userName = 'System';
        return;
      }

      const user = this.usersService.getUserFromId(parsedId);
      if (!user) {
        this.userName = 'Name nicht gefunden';
        return;
      }

      this.userName = this.usersService.getNameOfUser(parsedId);
      if (user.external_user) {
        this.userName += ' (extern)';
      }
    };
  },
};

export default angular.module('autoboard.userName', [])
  .component(UserNameDirective.selector, UserNameDirective)
  .name;
